import * as actions from "../actions/actionTypes";

export const storeColors = [
  "blue",
  "red",
  "#9b870c",
  "purple",
  "magenta",
  "cyan",
];

export const recentTrendsAttributes = {
  "Consumer Demographics": [
    "Gender",
    "Gen Z or Younger",
    "Millenials",
    "Gen X",
    "Baby Boomers",
    "Elders",
    "High Income",
    "Medium Income",
    "Low Income",
    "Local Consumer",
    "Tourist Consumer",
    "Monthly Visitor",
  ],
  "Consumer Interest": [
    "Fitness",
    "Lifestyle",
    "Fashion",
    "Holiday Shopping",
    "Customer Visiting Competitors",
  ],
  Footfall: [
    "Footfall Monday",
    "Footfall Tuesday",
    "Footfall Wednesday",
    "Footfall Thursday",
    "Footfall Friday",
    "Footfall Saturday",
    "Footfall Sunday",
  ],
};

export const reportTypes = {
  analyzeSegments: {
    value: "analyzeSegments",
    text: "Analyze Segments",
  },
  compareStores: {
    value: "compareStores",
    text: "Compare Stores",
  },
  analyzeDailyPatterns: {
    value: "analyzeDailyPatterns",
    text: "Analyze Daily Patterns",
  },
  analyzeRecentTrends: {
    value: "analyzeRecentTrends",
    text: "Analyze Recent Trends",
  },
};

const reducer = (state = {}, action) => {
  switch (action.type) {
    case actions.FETCH_DAILY_PATTERNS:
      return {
        ...state,
        dailyPatterns: action.patterns,
      };

    case actions.FETCH_RECENT_TRENDS:
      const recentTrends = action.payload;
      const recentTrendsStats = Object.keys(recentTrendsAttributes)
        .reduce((obj, key) => {
          obj = obj.concat(recentTrendsAttributes[key]);
          return obj;
        }, [])
        .map((a) => {
          const [min, max] = recentTrends.reduce(
            ([min, max], cur) => {
              const curmin = Math.min(...cur[a]);
              const curmax = Math.max(...cur[a]);
              return [
                Math.min(min, curmin) || min,
                Math.max(max, curmax) || max,
              ];
            },
            [Infinity, -Infinity]
          );
          return {
            name: a,
            min,
            max,
          };
        })
        .reduce((acc, cur) => {
          acc[cur.name] = [cur.min, cur.max];
          return acc;
        }, {});

      return {
        ...state,
        recentTrends,
        recentTrendsStats,
      };

    case actions.FETCH_DATA_STORES:
      return {
        ...state,
        stores: action.data,
      };

    case actions.SELECT_REPORT_TYPE:
      return {
        ...state,
        type: action.payload,
        selectedStores: [],
        selectedAttributes: [],
      };

    case actions.CLICK_STORE: {
      const id = action.payload;
      return {
        ...state,
        selectedStores: [id],
      };
    }

    case actions.SELECT_STORE: {
      const id = action.payload;
      const newSelectedStores = [...state.selectedStores];
      const index = newSelectedStores.indexOf(id);
      if (index !== -1) {
        newSelectedStores.splice(index, 1);
      } else {
        if (state.selectedStores.length > 5) return state;
        newSelectedStores.push(id);
      }
      return {
        ...state,
        selectedStores: newSelectedStores,
      };
    }

    case actions.CLICK_ATTRIBUTE: {
      const id = action.payload;
      return {
        ...state,
        selectedAttributes: [id],
      };
    }

    case actions.SELECT_ATTRIBUTE: {
      const value = action.payload;
      const newSelectedAttributes = [...state.selectedAttributes];
      const index = newSelectedAttributes.indexOf(value);
      if (index !== -1) {
        newSelectedAttributes.splice(index, 1);
      } else {
        if (state.selectedAttributes.length > 5) return state;
        newSelectedAttributes.push(value);
      }
      return {
        ...state,
        selectedAttributes: newSelectedAttributes,
      };
    }

    default:
      return state;
  }
};

export default reducer;
